import React from 'react';

// importing MyRouts where we located all of our theme
import MyRouts from './routers/routes'
import Pixel from './components/pixel';


function App() {
  return (
    <div>
      <Pixel />
      <MyRouts />
    </div>
  );
}

export default App;